import {
  LandingPageContainer,
  HeroSectionContainer,
  HeroSection,
  Logo,
  HeadingContainer,
  Heading,
  TextContainer,
  Text,
  SubText,
  Overlay,
  HeroBtnContainer,
  HeroButton,
  BenefitHead,
  BenefitProjectContainer,
  BenefitCard,
  CardHead,
  Video,
  FooterSection,
  FooterFormSection,
  FooterFormContainer,
  FormHeaderContainer,
  FormHeader,
  LandingPageForm,
  LandingPageFormGroup,
  LandingPageInput,
  FormButton,
  FooterInfoSection,
  FooterInfo,
} from "./style";
import logo from "../assets/img/boxs_logo_new_white.png";
import { useState } from "react";
import { FormFeedback } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { setUserFromLandingPage } from "../auth/service";

const LandingPage = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const enableFormSubmit =
    name.length > 0 && mobileNumber.length === 10 && /^\d+$/.test(mobileNumber);

  function submitForm() {
    setUserFromLandingPage({
      id: (Math.random() + 1).toString(36).substring(7),
      name,
      mobile: mobileNumber,
      isFromLandingPage: true,
    });
    navigate("/catalogs", { state: { setIdentity: true } });
  }

  return (
    <div style={{ background: "#eaeaea" }}>
      <LandingPageContainer>
        <HeroSectionContainer>
          <Overlay></Overlay>
          <HeroSection>
            <Logo
              height="44px"
              width="147px"
              mobileheight="35px"
              mobilewidth="123px"
              src={logo}
            />
            <HeadingContainer>
              <Heading>
                Project delays and issues because of <br />
                <b>Cutlist</b>?
              </Heading>
            </HeadingContainer>
            <TextContainer>
              <Text>
                Place your order online. <b>No Cutlist required.</b>
              </Text>
              <SubText>Made for Contractors &amp; Kitchen Companies</SubText>
            </TextContainer>
            <HeroBtnContainer className="d-flex justify-content-center">
              <a href="#footerSection">
                <HeroButton> Try Boxs for Free Now </HeroButton>
              </a>
            </HeroBtnContainer>
          </HeroSection>
        </HeroSectionContainer>
        <div className="py-4 bg-light">
          <BenefitHead>Key Benefits</BenefitHead>
          <BenefitProjectContainer margintop="3rem">
            <BenefitCard>
              <CardHead>Online Ordering in Minutes</CardHead>
              <p className="fs-6">
                No more Cutlists from your carpenter. Anyone can just select the
                cabinets, customize and place an order.
              </p>
            </BenefitCard>
            <BenefitCard>
              <CardHead>No more missing panels</CardHead>
              <p className="fs-6">
                All panels are grouped and packed as per the module, so no more
                hassle of missing panels or hardware.
              </p>
            </BenefitCard>
          </BenefitProjectContainer>
          <BenefitProjectContainer margintop="1.5rem">
            <BenefitCard>
              <CardHead>100% Customizable</CardHead>
              <p className="fs-6">
                No restriction on the size or materials. Choose any materials or
                hardware from our extensive database for your order.
              </p>
            </BenefitCard>
            <BenefitCard>
              <CardHead>Cabinet Packaging</CardHead>
              <p className="fs-6">
                No more loose materials or harwarde. Entire order is packed as
                per the cabinets for easier assembly and installation.
              </p>
            </BenefitCard>
          </BenefitProjectContainer>
        </div>
        <div className="pt-4 pb-5" style={{ backgroundColor: "#d2d2d3" }}>
          <BenefitHead>How it works?</BenefitHead>
          <div className="d-flex justify-content-center pt-4 px-4">
            <Video src="https://www.youtube.com/embed/chjMT9ZjtXQ?rel=0"></Video>
          </div>
        </div>
        <FooterSection id="footerSection" className="row">
          <FooterFormSection className="col-8">
            <FooterFormContainer>
              <FormHeaderContainer>
                <FormHeader>Try Boxs Now</FormHeader>
              </FormHeaderContainer>
              <LandingPageForm>
                <LandingPageFormGroup>
                  <LandingPageInput
                    className="unmask"
                    type="text"
                    placeholder="Name"
                    value={name}
                    invalid={name.length > 0 && name.trim().length < 1}
                    onChange={(ev) => setName(ev.target.value)}
                  ></LandingPageInput>
                  <FormFeedback>Please enter your Name.</FormFeedback>
                </LandingPageFormGroup>
                <LandingPageFormGroup>
                  <LandingPageInput
                    className="unmask"
                    type="text"
                    value={mobileNumber}
                    invalid={
                      mobileNumber.length > 0 &&
                      (mobileNumber.length !== 10 ||
                        !/^\d+$/.test(mobileNumber))
                    }
                    onChange={(ev) => setMobileNumber(ev.target.value)}
                    placeholder="Mobile Number"
                  ></LandingPageInput>
                  <FormFeedback>
                    Please enter a valid Mobile number.
                  </FormFeedback>
                </LandingPageFormGroup>
                <FormButton
                  disabled={!enableFormSubmit}
                  onClick={() => submitForm()}
                >
                  Submit
                </FormButton>
              </LandingPageForm>
            </FooterFormContainer>
          </FooterFormSection>
          <FooterInfoSection className="col-4">
            <Logo
              height="39px"
              width="137px"
              mobileheight="37px"
              mobilewidth="130px"
              src={logo}
            />
            <FooterInfo size="15px" className="mt-3">
              Email: support@boxs.in
            </FooterInfo>
            <FooterInfo size="15px">Mobile: +91 735 876 8746</FooterInfo>
            <FooterInfo size="14px" color="#c2c2c2">
              @All rights reserved
            </FooterInfo>
          </FooterInfoSection>
        </FooterSection>
      </LandingPageContainer>
    </div>
  );
};

export default LandingPage;
